import React, { useEffect, useRef, useState } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { Buffer } from 'buffer';
import { QRCodeSVG } from 'qrcode.react';
import { parseClasses } from '../../lib/ep';
import { useCSS } from '../../lib/hooks';

import { SecondaryButton } from '../builder/ActionButton';
import SaveButton from '../builder/SaveButton';
import ButtonCollection from '../builder/ButtonCollection';
import CopyLink from '../builder/CopyLink';

const QRViewer = (props) => {
	useCSS('comp/qr_viewer.css');

	const url = props?.url ?? false;

	const [ downloaded, setDownloaded ] = useState(false);

	useEffect(() => {
		setDownloaded(false);
	}, [ props.url ]);

	if(url === false) return null;

	const size = props?.size ?? 150;
	const level = props?.level ?? 'L';	// L|M|Q|H
	const background_color = props?.background_color ?? "#FFFFFF";
	const foreground_color = props?.foreground_color ?? "#000000"
	const watermark = props?.watermark ?? null;
	const enable_copy = props?.enable_copy ?? true;

	const qr_id = useRef(`_${props?.id ?? uuidv4().split("-")[0]}`);
	const qr_filename = props?.filename ?? `qr${qr_id.current}`;

	const default_watermark_props = {
		src:"easypromos_logo.png",
		x:null,
		y:null,
		height:24,
		width:24,
		excavate:true,
	};

	const qr_props = {
		value:url,
		size,
		level,
		bgColor:background_color,
		fgColor:foreground_color,
		imageSettings:watermark,
	};

	const encodeBase64 = (data) => {
		return Buffer.from(data).toString('base64');
	};

	const decodeBase64 = (data) => {
		return Buffer.from(data, 'base64').toString('ascii');
	};

	const download = (cb) => {
		setTimeout(() => {
			const svg = document.querySelector(`#${qr_id.current} > svg`);
			const svgContent = new XMLSerializer().serializeToString(svg);
			const canvas = document.createElement('canvas');
			const ctx = canvas.getContext('2d');

			const img = new Image();
			img.onload = () => {
				canvas.width = img.width;
				canvas.height = img.height;
				ctx.drawImage(img, 0, 0);

				let a = document.createElement('a');
				a.download = `${qr_filename}.png`;
				a.href = canvas.toDataURL('image/png', 1.0).replace('image/png', 'image/octet-stream');
				a.click();

				if(cb != undefined) cb();
			}

			img.src = `data:image/svg+xml;base64,${encodeBase64(svgContent)}`;
		}, 500);
	};

	let classes = props?.classname ?? `gui_qr_viewer`;
	classes = parseClasses(classes, props._class, 'other');

	const enable_regenerate = (props.onRegenerate != undefined) ? true : false;
	const enable_download = props?.enable_download ?? true;

	let has_actions = false;
	if(enable_copy) has_actions = true;
	if(enable_regenerate) has_actions = true;
	if(enable_download) has_actions = true;
	if(props?.hide_actions ?? false) has_actions = false;

	return (
		<>
			<div class={classes} style={props._style}>
				<QRCodeSVG
					{...qr_props}
					includeMargin={false}
				/>

				{(has_actions) && (
					<ButtonCollection>
						{(enable_copy) && (
							<CopyLink
								copy_link={url}
								type='button'
							>Copy URL</CopyLink>
						)}

						{(enable_regenerate) && (
							<SecondaryButton
								icon='knk-reload'
								onClick={props.onRegenerate}
							>Regenerate QR code</SecondaryButton>
						)}

						{(enable_download && (!downloaded || props.onFinish == undefined)) && (
							<SaveButton
								icon="knk-download"
								onClick={(e, cb) => download(() => {
									setDownloaded(true);
									cb();
								})}
							>Download QR code</SaveButton>
						)}

						{(enable_download && (downloaded && props.onFinish != undefined)) && (
							<SecondaryButton
								icon="knk-on"
								onClick={props.onFinish}
							>Ready!</SecondaryButton>
						)}
					</ButtonCollection>
				)}
			</div>

			<div id={qr_id.current} style={{ display:'none', opacity:'0' }}>
				<QRCodeSVG
					{...qr_props}
					size={512}
					includeMargin={true}
				/>
			</div>
		</>
	)
};

export default QRViewer;